/* oxlint-disable-next-line no-restricted-imports -- use v4 so that trace ids look distinct */
import { v4 } from "uuid";

export function createTraceId(): string {
  return v4();
}
